import { render, staticRenderFns } from "./TambahKantor.vue?vue&type=template&id=35fa0762&scoped=true"
import script from "./TambahKantor.vue?vue&type=script&lang=js"
export * from "./TambahKantor.vue?vue&type=script&lang=js"
import style0 from "./TambahKantor.vue?vue&type=style&index=0&id=35fa0762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fa0762",
  null
  
)

export default component.exports